
import { Vue, Component, Watch } from "vue-property-decorator";
import { api_user, add_user } from "@/http/user";
import PageHeader from "@/components/pageHeader/index.vue";
import { ElForm } from "element-ui/types/form";
import { api_store, store } from "@/http/store";
import { api_meal, meal } from "@/http/meal";
import axios from "axios";
import {
  provinceAndCityData,
  regionData,
  CodeToText,
} from "element-china-area-data";
import Upimg from "@/components/storeupimg/index.vue";

@Component({
  components: {
    Upimg,
    PageHeader,
  },
})
export default class extends Vue {
  info: add_user = {
    id: "",
    phone: "",
    pay_amount: "0",
    wallet: "0",
    user_wallet: "",
    nickname: "",
    avatar_url: "icon/PixPin_1.png",
    image: "",
    store: "",
    user_level: "0",
    user_meal_id: "0",
    mealIds: [],
    userMealNames: [],
    member_name: "",
    type: 1,
  };

  imageUrls: string[] = [];
  options = provinceAndCityData;
  selectedOptions: string[] = [];

  rules = {
    nickname: [{ required: true, message: "请填写用户名称" }],
    pay_amount: [{ required: true, message: "请填写支付金额" }],
    wallet: [{ required: true, message: "请填写充值金额" }, {
      validator: (rule:any, value:any, callback:any) => {
        if (value < 0) {
          callback(new Error("充值金额不能为负数"));
        } else {
          callback();
        }
      },
      trigger: ["blur", "change"]
    }],
    store: [{ required: true, message: "请选择门店" }],
    phone: [
      { required: true, message: "请填写手机号码", trigger: "blur" },
      {
        pattern: /^(?:(?:\+|00)86)?1\d{10}(-[1-9])?$/,
        message: "请输入有效的手机号码",
        trigger: ["blur", "change"]
      }
    ],
    image: [{ required: true, message: "请上传用户照片" }]
  };

  // 新增一个 select
  async addSelect() {
    this.mealIds.push(''); // 新增一个空值，表示新 select 默认未选择
  }

  // 删除指定 index 的 select
  async removeSelect(index:number) {
    if (this.mealIds.length > 1) {
      this.mealIds.splice(index, 1); // 删除该索引的选项
      this.info.mealIds.splice(index, 1);
      this.userMealAmount();
    } else {
      // 可选：提示用户至少保留一个
      this.$message.warning('至少要保留一个会员卡选项');
    }
  }

  async submit() {
    await (this.$refs["form"] as ElForm | undefined)?.validate();
    // if (this.id) {
    //   await api_user.edit(this.info);
    // } else {
    if(this.hasDuplicates(this.info.mealIds)){
      this.$message.error('不能选择重复的会员卡，请检查！');
      return;
    }
    //   this.paymentDialogVisible = true;
    this.info.type = this.type
    if(this.info.id && this.info.id!=""){
      await api_user.add_user_meal(this.info).then((res: any) => {
        if(res.status === '0'){
          this.paymentDialogVisible = true;
          this.currentOrderNo = res.order_no
          this.qrcode = `https://images.xiyuebiaoju.com/${res.qrcode}`;
          this.startPollingOrderStatus(res.order_no);
        }else if(res.status === '1'){
          // 0元订单成功
          this.$message.success("添加成功");
          setTimeout(() => {
            this.$router.push('/user');
          }, 1000);
        }
      });
    }else{
      await api_user.create(this.info).then((res: any) => {
        if(res.status === '0'){
          this.paymentDialogVisible = true;
          this.currentOrderNo = res.order_no
          this.qrcode = `https://images.xiyuebiaoju.com/${res.qrcode}`;
          this.startPollingOrderStatus(res.order_no);
        }else if(res.status === '1'){
          // 0元订单成功
          this.$message.success("添加成功");
          setTimeout(() => {
            this.$router.push('/user');
          }, 1000);
        }
      });
    }
    //   this.qrcode = res.qrcode;
    //   this.startPollingOrderStatus(res.order_id);

    // }
    // this.$router.go(-1);
  }

  async checkStore(){
    this.mealIds = [''];
    this.info.mealIds = [''];
    this.info.pay_amount = "0";
    this.info.wallet = "0";
    this.get_user_meal_list();
  }

  async checkForDuplicates(){
    if(this.hasDuplicates(this.info.mealIds)){
      this.$message.error('不能选择重复的会员卡，请检查！');
    }
    this.userMealAmount();
  }

  labels = 0;
  amount = 0;
  gifts = 0;
  async userMealAmount(){
    this.labels = 0;
    this.amount = 0;
    this.gifts = 0;
    this.info.mealIds.forEach((item: any) => {
      var meal = this.mealList.find((list) => list.id === item);
      this.labels += Number(meal.labels)
      this.amount += Number(meal.amount)
      this.gifts += Number(meal.gifts)
    });
    this.info.pay_amount = this.labels+"";
    this.info.wallet = (this.amount + this.gifts)+"";
  }

  hasDuplicates(array:any[]) {
    return new Set(array).size !== array.length;
  }

  async get_info() {
    const userInfo = await api_user.get_info(this.id as number);

    userInfo.pay_amount = userInfo.pay_amount != null ? String(userInfo.pay_amount) : "0";
    userInfo.user_wallet = userInfo.wallet != null ? String(userInfo.wallet) : "0";
    userInfo.wallet = "0";
    userInfo.mealIds = [];
    if (userInfo.member_name && userInfo.member_name !== '') {
      userInfo.userMealNames = userInfo.member_name.split('、');
    } else {
      userInfo.userMealNames = [];
    }

    // 处理用户照片
    if (typeof userInfo.image === "string") {
      const domain = "";
      this.imageUrls = userInfo.image
          .split(",")
          .map((url) => domain + url.trim());
    }

    this.info = userInfo;

    if(this.info.store != undefined){
      await this.get_user_meal_list();
    }
    // this.options = options;
  }

  // 监听图片数据
  @Watch("imageUrls")
  setImage(val:string) {
    //const domain = "https://images.xiyuebiaoju.com/";
    const domain = "";
    this.info.image = val;
  }

  get id(): undefined | number {
    return this.$route.query.id as any;
  }

  get type(): undefined | number {
    return this.$route.query.type as any;
  }

  // 获取门店列表
  storeList: any[] = [];
  async get_store_list() {
    const res = await api_store.get_list({ page_size: 10000 });
    const list: any[] = [];
    res.results.forEach((item: any) => {
      (item.value = item.id), (item.label = item.name);
    });
    this.storeList = list.concat(res.results);
  }
  // 获取会员卡列表
  mealIds = ['']
  mealList: any[] = [];
  async get_user_meal_list() {
    const res = await api_meal.get_list({ page_size: 10000, store_id:"0,"+this.info.store });
    res.results.forEach((item: any) => {
      (item.value = item.id), (item.label = item.name+"（支付金额："+item.labels+"元，充值余额："+(Number(item.amount)+Number(item.gifts))+"元）");
    });
    this.mealList = res.results;
  }
  created() {
    this.get_store_list();
    if (this.id === undefined) return;
    this.get_info();
  }
  // 付款二维码弹框
  paymentDialogVisible = false;
  // 付款方式相关属性
  paymentType: 'qrcode' | 'aliqrcode' | 'scangun' = 'qrcode'; // 付款方式：二维码或扫码枪
  scannedPaymentCode = ''; // 扫码得到的付款码
  scanStatus = '等待扫码'; // 扫码状态
  // 扫码枪监听相关属性
  paymentNextCode: number | null = null;
  paymentNextTime: number = 0;
  paymentLastCode: any | string = "";
  paymentLastTime: any | string = "";
  paymentScanCode: string = "";
  // 当前订单信息
  currentOrderNo: string = "";
  // 扫码付款轮询定时器
  scanPayTimer: any = null;

  qrcode = "";
  aliqrcode = "";

  pollingTimer: any = null;

  // 关闭付款二维码弹框
  closePaymentDialog() {
    this.paymentDialogVisible = false;
    // 停止扫码枪监听
    this.stopPaymentScanMonitor();
    // 停止扫码付款轮询
    this.stopScanPayPolling();
    // 停止订单状态轮询
    if (this.pollingTimer) {
      clearInterval(this.pollingTimer);
      this.pollingTimer = null;
    }
    // 重置扫码相关状态
    this.paymentType = 'qrcode';
    this.scannedPaymentCode = '';
    this.scanStatus = '等待扫码';
    this.paymentScanCode = '';
    this.paymentLastCode = '';
    this.paymentLastTime = '';
    // 清空订单信息
    this.currentOrderNo = "";
  }

  // 付款方式改变时的处理
  onPaymentTypeChange(value: 'qrcode' | 'aliqrcode' | 'scangun') {
    this.paymentType = value;
    this.resetScanState();

    if (value === 'scangun') {
      this.startPaymentScanMonitor();
    } else if (value === 'aliqrcode'){
      this.stopPaymentScanMonitor();
      if(!this.aliqrcode){
        this.ali_pay();
      }
    } else {
      this.stopPaymentScanMonitor();
    }
  }

  async ali_pay() {
    const res = await api_user.user_ali_pay({ order_no: this.currentOrderNo });
    console.log(res)
    this.aliqrcode = res.qrcode
  }

  // 重置扫码状态
  resetScanState() {
    this.scannedPaymentCode = '';
    this.scanStatus = '等待扫码';
    this.paymentScanCode = '';
    this.paymentLastCode = '';
    this.paymentLastTime = '';
  }

  // 启动付款扫码枪监听
  startPaymentScanMonitor() {
    console.log('启动付款扫码枪监听');
    this.scanStatus = '监听中...';
    this.addPaymentScanMonitor();
  }

  // 停止付款扫码枪监听
  stopPaymentScanMonitor() {
    console.log('停止付款扫码枪监听');
    if (window.document.onkeypress) {
      window.document.onkeypress = null;
    }
  }

  // 监听键盘输入（付款扫码枪逻辑）
  addPaymentScanMonitor() {
    window.document.onkeypress = async (e) => {
      // 只在付款扫码枪模式下处理
      if (this.paymentType !== 'scangun' || !this.paymentDialogVisible) {
        return;
      }

      if (window.event) {
        // IE
        this.paymentNextCode = e.keyCode;
      } else if (e.which) {
        // Netscape/Firefox/Opera
        this.paymentNextCode = e.which;
      }

      if (e.which === 13) {
        // 键盘回车事件
        if (this.paymentScanCode.length < 3) return; // 扫码枪的速度很快，手动输入的时间不会让code的长度大于2
        console.log("扫码结束,付款码：", this.paymentScanCode);

        // 将扫码内容设置为付款码
        this.scannedPaymentCode = this.paymentScanCode;
        this.scanStatus = '扫码完成';

        this.paymentLastCode = "";
        this.paymentLastTime = "";

        // 扫码完成后自动提交到API
        await this.processPayment();
        return;
      }

      this.paymentNextTime = new Date().getTime();
      if (!this.paymentLastTime && !this.paymentLastCode) {
        this.paymentScanCode = ""; // 清空上次的条形码
        this.paymentScanCode += e.key;
        this.scanStatus = '扫码中...';
        console.log("扫码开始---", this.paymentScanCode);
      }
      if (
          this.paymentLastCode &&
          this.paymentLastTime &&
          this.paymentNextTime - this.paymentLastTime > 500
      ) {
        // 当扫码前有keypress事件时,防止首字缺失
        this.paymentScanCode = e.key;
        console.log("防止首字缺失。。。", this.paymentScanCode);
      } else if (this.paymentLastCode && this.paymentLastTime) {
        this.paymentScanCode += e.key;
        console.log("扫码中。。。", this.paymentScanCode);
      }
      this.paymentLastCode = this.paymentNextCode;
      this.paymentLastTime = this.paymentNextTime;

      // 更新显示的扫码内容
      this.scannedPaymentCode = this.paymentScanCode;
    };
  }

  // 处理扫码枪付款
  async processPayment() {
    if (!this.scannedPaymentCode) {
      this.$message.error('请先扫描付款码');
      return;
    }

    if (!this.currentOrderNo) {
      this.$message.error('订单信息缺失');
      return;
    }

    console.log('处理扫码枪付款，付款码：', this.scannedPaymentCode);
    console.log('订单号：', this.currentOrderNo);

    // 设置提交中状态
    this.scanStatus = '正在提交...';

    try {
      // 调用扫码付款API
      const response = await api_user.scan_pay({
        auth_code: this.scannedPaymentCode,
        // auth_code: '133437134791378304',
        order_no: this.currentOrderNo
      });

      console.log('扫码付款API响应:', response);

      // 处理新的API响应格式
      if (response.code === 200) {
        if (response.msg === '需要用户输入支付密码') {
          // 需要用户输入支付密码
          this.$message.success('扫码成功，等待用户输入密码');
          this.scanStatus = '等待用户输入密码';

          // 停止任何订单状态轮询
          if (this.pollingTimer) {
            clearInterval(this.pollingTimer);
            this.pollingTimer = null;
          }

          // 开始扫码付款接口轮询
          this.startScanPayPolling();
        } else if (response.msg === '扣款成功') {
          // 扣款成功
          this.$message.success('付款成功！');
          this.scanStatus = '扣款成功';

          // 停止所有轮询
          this.stopScanPayPolling();
          if (this.pollingTimer) {
            clearInterval(this.pollingTimer);
            this.pollingTimer = null;
          }
        } else {
          // 其他状态，显示返回的消息
          this.scanStatus = response.msg;
          if (response.msg.includes('失败') || response.msg.includes('错误')) {
            this.$message.error(response.msg);
            // 重置扫码状态，允许重新扫码
            this.resetScanState();
          } else {
            this.$message.success(response.msg);
          }
        }
      } else {
        // 其他错误状态，显示返回的消息并重置扫码状态
        this.scanStatus = response.msg || '扫码失败';
        this.$message.error(response.msg || '扫码失败，请重新扫码');
        this.resetScanState();
      }

    } catch (error: any) {
      console.error('扫码付款失败:', error);

      // 处理网络错误或服务器返回的错误信息
      if (error.response && error.response.data && error.response.data.msg) {
        this.scanStatus = error.response.data.msg;
        this.$message.error(error.response.data.msg);
      } else {
        this.scanStatus = '网络错误，请重新扫码';
        this.$message.error('网络错误，请重试');
      }

      // 重置扫码状态，允许重新扫码
      this.resetScanState();
    }
  }

  // 开始扫码付款轮询
  startScanPayPolling() {
    // 停止之前的轮询
    this.stopScanPayPolling();

    console.log('开始扫码付款轮询');

    // 每3秒轮询一次
    this.scanPayTimer = setInterval(async () => {
      await this.pollScanPayStatus();
    }, 3000);
  }

  // 停止扫码付款轮询
  stopScanPayPolling() {
    if (this.scanPayTimer) {
      clearInterval(this.scanPayTimer);
      this.scanPayTimer = null;
      console.log('停止扫码付款轮询');
    }
  }

  // 轮询扫码付款状态
  async pollScanPayStatus() {
    if (!this.currentOrderNo) {
      console.error('轮询失败：订单信息缺失');
      this.stopScanPayPolling();
      return;
    }

    try {
      const response = await api_user.scan_pay({
        auth_code: this.scannedPaymentCode,
        // auth_code: '133437134791378304',
        order_no: this.currentOrderNo
      });

      console.log('轮询扫码付款API响应:', response);

      if (response.code === 200) {
        if (response.msg === '扣款成功') {
          // 扣款成功，停止轮询
          this.stopScanPayPolling();
          // 停止订单状态轮询（如果有的话）
          if (this.pollingTimer) {
            clearInterval(this.pollingTimer);
            this.pollingTimer = null;
          }
          this.$message.success('付款成功！');
          this.scanStatus = '扣款成功';
        } else if (response.msg === '需要用户输入支付密码') {
          // 仍在等待用户输入密码，继续轮询
          this.scanStatus = '等待用户输入密码';
        } else {
          // 其他状态，更新显示信息
          this.scanStatus = response.msg;
        }
      } else {
        // 轮询过程中出现错误，停止轮询
        this.stopScanPayPolling();
        this.scanStatus = response.msg || '付款失败';
        this.$message.error(response.msg || '付款失败，请重新扫码');
        this.resetScanState();
      }

    } catch (error: any) {
      console.error('轮询扫码付款状态失败:', error);

      // 轮询过程中出现网络错误，停止轮询
      this.stopScanPayPolling();

      if (error.response && error.response.data && error.response.data.msg) {
        this.scanStatus = error.response.data.msg;
        this.$message.error(error.response.data.msg);
      } else {
        this.scanStatus = '网络错误，请重新扫码';
        this.$message.error('网络错误，请重试');
      }

      this.resetScanState();
    }
  }

  handleClose(done: any) {
    this.$confirm("确认关闭？")
        .then((_) => {
          // this.phone = "";
          // this.user_info = {};
          if (this.pollingTimer) {
            clearInterval(this.pollingTimer);
            this.pollingTimer = null;
          }
          done();
        })
        .catch((_) => {});
  }
  startPollingOrderStatus(orderId: string) {
    if (this.pollingTimer) clearInterval(this.pollingTimer);

    // 立即检查一次状态
    this.checkOrderStatus(orderId);

    // 每10秒轮询一次
    this.pollingTimer = setInterval(() => {
      this.checkOrderStatus(orderId);
    }, 10000);
  }
  // 判断订单是否完成
  async checkOrderStatus(orderId: string) {
    try {
      const res = await api_user.pay_check({ order_no: orderId });
      if (res.pay_status === 1) {
        // 订单成功：关闭弹窗、提示、清除定时器
        clearInterval(this.pollingTimer);
        this.pollingTimer = null;
        this.$message.success("添加成功");
        setTimeout(() => {
          //this.$router.go(-1);
          this.$router.push('/user');
        }, 1000);
      }
    } catch (error) {
      console.error("订单状态查询失败:", error);
    }
  }
  beforeDestroy() {
    if (this.pollingTimer) {
      clearInterval(this.pollingTimer);
      this.pollingTimer = null;
    }

    // 确保停止付款扫码枪监听
    this.stopPaymentScanMonitor();
    // 确保停止扫码付款轮询
    this.stopScanPayPolling();
  }

  // 拍照相关变量
  cameraDialogVisible = false;
  tempPhotoUrl = "";

  // 打开摄像头
  async openCamera() {
    this.cameraDialogVisible = true;
    this.tempPhotoUrl = "";
    await this.$nextTick();
    try {
      const videoElement = this.$refs.video as HTMLVideoElement;
      if (videoElement) {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: true,
          audio: false
        });
        videoElement.srcObject = stream;
      }
    } catch (error: any) {
      if (error.name === "NotAllowedError") {
        this.$message.error("请允许访问摄像头");
      } else {
        this.$message.error("无法访问摄像头");
      }
      this.cameraDialogVisible = false;
    }
  }

  // 拍照
  async takePhoto() {
    const videoElement = this.$refs.video as HTMLVideoElement;
    if (!videoElement || !videoElement.srcObject) {
      this.$message.error("未能获取到视频流");
      return;
    }
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    canvas.width = videoElement.videoWidth;
    canvas.height = videoElement.videoHeight;
    ctx.drawImage(videoElement, 0, 0, canvas.width, canvas.height);

    const imageData = canvas.toDataURL("image/jpeg");
    this.tempPhotoUrl = imageData;
  }

  // 重新拍照
  retakePhoto() {
    this.tempPhotoUrl = "";
  }

  // 确认使用照片
  async confirmPhoto() {
    try {
      const blob = this.dataURItoBlob(this.tempPhotoUrl);
      const file = new File([blob], "user_photo.jpg", { type: "image/jpeg" });
      const formData = new FormData();
      formData.append("file", file);

      const response = await axios.post(
          "https://api.xiyuebiaoju.com/user_file_upload/",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
      );

      if (response.data.code === 200) {
        this.info.image = response.data.data;
        this.$message.success("照片上传成功");
        this.closeCameraDialog();
      } else {
        throw new Error("上传失败");
      }
    } catch (error) {
      this.$message.error("照片上传失败");
    }
  }

  // 关闭摄像头
  closeCameraDialog() {
    const videoElement = this.$refs.video as HTMLVideoElement;
    if (videoElement && videoElement.srcObject) {
      const stream = videoElement.srcObject as MediaStream;
      stream.getTracks().forEach(track => track.stop());
    }
    this.cameraDialogVisible = false;
    this.tempPhotoUrl = "";
  }

  // 处理关闭弹窗
  handleCameraClose() {
    this.$confirm("确认关闭摄像头？")
        .then(() => {
          this.closeCameraDialog();
        })
        .catch(() => {});
  }

  // Base64转Blob
  dataURItoBlob(dataURI: string) {
    const splitIndex = dataURI.indexOf(",");
    const mimeString = dataURI
        .substring(0, splitIndex)
        .split(":")[1]
        .split(";")[0];
    const byteString = atob(dataURI.split(",")[1]);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);

    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }

    return new Blob([int8Array], { type: mimeString });
  }
}
